import React, { Component } from 'react';
import TextTruncate from 'react-text-truncate';
import { get, isEmpty } from 'lodash';
import { Link } from 'react-router';

class RowItemDanhSachThongKeGiamSatDonCu extends Component {
  getLocal(data) {
    let address = [];
    const checkAddressData = (addressData) => {
      if (!isEmpty(addressData)) {
        address.push(addressData);
      }
    }
    checkAddressData(get(data, 'diaChi'));
    checkAddressData(get(data, 'toThon'));
    checkAddressData(get(data, 'phuongXaCongDan.ten'));
    checkAddressData(get(data, 'quanHuyenCongDan.ten'));
    checkAddressData(get(data, 'tinhThanhCongDan.ten'));
    return address.join(", ");
  }

  showThongTinCongDan() {
    let size = '';
    const { listNguoiDungDon } = this.props.item;
    if (!isEmpty(listNguoiDungDon)) {
      size = listNguoiDungDon.length;
    }
    if (!size) {
      return null;
    }
    return (
      <div>
        <li className="txt-bold">{get(listNguoiDungDon, '[0].hoVaTen')}</li>
        <li>{this.getLocal(get(listNguoiDungDon, '[0]'))}</li>
        <li>{get(listNguoiDungDon, '[0].soDienThoai')}</li>
      </div>
    );
  }

  render() {
    const { nguonDonInfo, soNguoi, loaiDonInfo, noiDung, donCuId } = this.props.item;
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            {this.showThongTinCongDan()}
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              <Link
                className="txt-underline"
                to={`/chi-tiet-don-cu/${donCuId}`} >
                <TextTruncate
                  line={3}
                  truncateText="…"
                  text={noiDung}
                />
              </Link>
            </li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              {get(loaiDonInfo, 'ten')}
            </li>
            <li>{`${soNguoi} người`}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{get(nguonDonInfo, 'ten')}</li>
          </ul>
        </td>
      </tr>
    );
  }
}

export default RowItemDanhSachThongKeGiamSatDonCu


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-giam-sat/datatable/RowItemDanhSachThongKeGiamSatDonCu.jsx